<template>
  <div class="toolView">

    <div class="title">
      <div class="caseName">{{collectionName}}</div>
      <div class="cite" @click="goto">全部引用</div>
    </div>

    <div class="chat-container">
        <div v-html="mdToHtml(getMsg(this.message))"></div>
    </div>
  </div>



</template>

<script>
// import VConsole from 'vconsole'

// new VConsole()
import ajax from '../api/ajax';
import marked from 'marked';
import DOMPurify from 'dompurify';
export default {
  name: "NutritionToolView",
  data() {
    return {
      content: '',
      message: "",
      collectionId:"",
      collectionName:""

    };
  },
  mounted() {
    this.dataId = this.$route.query.dataId
    this.citeId = this.$route.query.citeId
    this.chatId = this.$route.query.chatId
    this.chatType = this.$route.query.chatType
    document.title = `AI营养处方助手`;
    this.getQuota()
  },

  methods: {
    getQuota(){
      ajax
          .Post({
            url: '/api/ai/hlxj/chat/fastgpt/selectQuotaById',
            data: {
              chatId: this.chatId ,
              dataId: this.dataId ,
              id: this.citeId ,
              chatType: this.chatType
            }
          }).then(res => {
            console.log("成功", res)
        if (res.data.code == 200) {
          this.message = res.data.data.q
          this.collectionId = res.data.data.collection._id
          this.collectionName = res.data.data.collection.name
        } else {
          console.log("失败" )
        }
      })
    },
    goto(){

      this.$router.push({
        path: '/caseView',
        query: {
          citeId: this.citeId,
          dataId: this.dataId,
          chatId: this.chatId ,
          collectionId: this.collectionId ,
          collectionName: this.collectionName ,
          chatType: this.chatType
        }
      });

    },
    getMsg(msg) {
      // 如果 msg 是字符串，直接返回
      if (typeof msg === 'string') {
        return msg;
      }
      // 如果是对象，按原来的逻辑处理
      const textObj = msg?.value?.find(v => v.type === "text");
      return textObj?.text?.content || "";
    },
    // Markdown -> 安全 HTML
    mdToHtml(markdown) {
      const renderer = new marked.Renderer();

      // 自定义 link 渲染
      renderer.link = (href, title, text) => {
        if (/^\w+$/.test(href)) {
          // 返回自定义 span 标签，不用 onclick
          return `<span style="color: deepskyblue" class="cite-tag" > “” </span>`;
        } else {
          return `<a href="${text}" target="_blank">${text}</a>`;
        }
      };

      const rawHtml = marked.parse(markdown, {renderer});
      // 保留 data-cite 属性
      return DOMPurify.sanitize(rawHtml, {ADD_ATTR: ['data-cite']});
    },
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.toolView{
  background-color: #fff;
}

.chat-container {
  height: 100vh;
  overflow: auto;
  padding: 15px;
}
.title{
  padding:15px 15px 0 15px;
  display: flex;
  justify-content: space-between;
}
.cite{
  color: dodgerblue;
  font-size: 14px;
}
.caseName{
  font-size: 14px;
  margin-right: 10px;
  height: auto;
  line-height: 30px;
  font-weight: 400;
  text-align: center;
  font-style: normal;
  margin-bottom: 10px;
  border-radius: 8px;
  border: 1px solid #E4E4E4;
  padding: 0 10px;
}


</style>
